import { render, staticRenderFns } from "./kunjungan.vue?vue&type=template&id=0433db90"
import script from "./kunjungan.vue?vue&type=script&lang=js"
export * from "./kunjungan.vue?vue&type=script&lang=js"
import style0 from "./kunjungan.vue?vue&type=style&index=0&id=0433db90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports